module.exports = __webpack_public_path__ + "img/9 filters-06.2c2a6365.svg";